// extracted by mini-css-extract-plugin
export default {"appointmentSelect":"LinkedAppointmentSelect_appointmentSelect__MNb0S","textEllipsis":"LinkedAppointmentSelect_textEllipsis__8T+e8"};